import React from 'react'
import { Field } from 'redux-form'
import { connect } from 'react-redux'
import classnames from 'classnames'

import { selectCurrentRefiVehicle } from '../../../reducers'
import { Vehicle } from '../../../core/types'
import { updateTrimOptions } from '../../refiApp/vehicle/vehicleActions'

export type Callback<T = void> = (...args: any) => T

export interface Option {
  label: string
  requiredBadge?: string[]
  taskBucket?: string
  value: string
}

export interface Props {
  options: Option[] | null
  name: string
  vehicle: Vehicle
  updateTrimOptions: Callback
}

const CheckBoxElement = ({
  vehicle,
  updateTrimOptions,
  index,
  option,
  name,
}) => {
  const { label, value, checked } = option
  const handleChange = (event) => {
    const { value, checked } = event.target

    updateTrimOptions(vehicle, { value: Number(value), checked })
  }

  return (
    <div key={`checkbox-${name}[${index}]`}>
      <input
        type="checkbox"
        name={`${name}[${index}]`}
        id={`checkbox-${name}[${index}]`}
        value={value}
        checked={checked}
        onChange={handleChange}
        disabled={false}
        className={classnames('form__checkbox', {
          'form__checkbox--disabled': false,
          'form__control--error': false,
        })}
      />
      <label
        className={classnames({
          'form__control--disabled-text': false,
        })}
        htmlFor={`checkbox-${name}[${index}]`}
      >
        {label}
      </label>
    </div>
  )
}

const CheckBoxField = ({ options, vehicle, updateTrimOptions, name }) => {
  return (
    <div
      className={classnames('form__checkbox-group-wrapper', {
        'form__checkbox-group-wrapper--row': false,
        'form__checkbox-group-wrapper--tasks': false,
      })}
    >
      {options.map((option, index) => (
        <CheckBoxElement
          vehicle={vehicle}
          updateTrimOptions={updateTrimOptions}
          index={index}
          option={option}
          name={name}
          key={`checkbox-${name}[${index}]`}
        />
      ))}
    </div>
  )
}

export const CheckboxTrimGroup = (props) => {
  const { options, name, vehicle, updateTrimOptions } = props

  return (
    <Field
      {...props}
      type="checkbox"
      component={() => (
        <CheckBoxField
          options={options}
          name={name}
          vehicle={vehicle}
          updateTrimOptions={updateTrimOptions}
        />
      )}
    />
  )
}

export const mapStateToProps = (state) => {
  return {
    vehicle: selectCurrentRefiVehicle(state),
  }
}

export default connect(mapStateToProps, { updateTrimOptions })(
  CheckboxTrimGroup
)
